import { createApiCallActions } from '../../../../common/store/generic.actions';
import { WorkScheduleModel } from './types';

export const workScheduleActions = {
  getById: createApiCallActions<WorkScheduleModel>('workSchedule', 'getById'),
  createInstance: createApiCallActions<WorkScheduleModel>(
    'workSchedule',
    'createInstance',
  ),
  add: createApiCallActions<WorkScheduleModel>('workSchedule', 'add'),
  update: createApiCallActions<WorkScheduleModel>('workSchedule', 'update'),
  delete: createApiCallActions<boolean>('workSchedule', 'delete'),
};

export type WorkScheduleAction = typeof workScheduleActions;
